import Vue from "vue"; //引入vue
import VueI18n from "vue-i18n";
import enLocale from "./en";
import zhLocale from "./zh";
import { LOCAL_LANGUAGE } from "../../api/localStorageName";
Vue.use(VueI18n); // 通过插件的形式挂载

// 引入本地
const messages = {
  en: {
    message: "hello",
    ...enLocale
  },
  zh: {
    message: "你好",
    ...zhLocale
  }
};

// 创建国际化实例
let language = navigator && navigator.language ? navigator.language : "zh-CN";
const local_language = localStorage.getItem(LOCAL_LANGUAGE)
language = local_language || language
// language = language.startsWith("zh") ? "zh" : "en";


language = language.toUpperCase();
// const elementLang = language=='en'?en:zh
language = language.startsWith("ZH") ? "zh" : "en";


const i18n = new VueI18n({
  // 设置默认语言
  locale: language,
  messages
});
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js